import { Vendors } from "./VendorsPage";
import { VendorsProvider } from "./context/VendorsContext";

const VendorsPage = () => {
	return (
		<VendorsProvider>
			<Vendors />
		</VendorsProvider>
	);
};

export default VendorsPage;
